// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const goalActionsAPI = createApi({
  reducerPath: 'goalActionsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    createGoalAction: builder.mutation<any, GoalActionsArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/goal/action/create`,
        method: 'POST',
        data: payload,
      }),
    }),
    updateGoalAction: builder.mutation<any, GoalActionsArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/goal/action/update`,
        method: 'POST',
        data: payload,
      }),
    }),
    updateGoalActionStatus: builder.mutation<any, GoalActionsStatusArgTypes>({
      query: ({ affiliateCode, aboNumber, goalActionId, statusId }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/goal/action/${goalActionId}/update/status/${statusId}`,
        method: 'POST',
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateGoalActionMutation,
  useUpdateGoalActionMutation,
  useUpdateGoalActionStatusMutation,
} = goalActionsAPI;
